import { useCallback } from 'react'
import { sleep } from '../utils'
import ElectronIPC, { FfmpegExecResult } from './ElectronIPC'
import { env } from './EnvironmentVariables'

// The info of the file we want to convert.
export type ConversionFileInfo = {
    outputFilename: string
    outputFilenameBase: string
    outputFileFullPath: string
    outputFileDirectory: string
}

export function useWebmConverter({ pathDelimiter }: { pathDelimiter: string }) {
    const convertWebm = useCallback(
        async (
            info: ConversionFileInfo,
            outputExtension: string,
            conversionFlags: string[],
            onSuccess: (fileInfo: ConversionFileInfo) => void,
            onError: (code: number, message?: string) => void
        ) => {
            const src = info.outputFileFullPath
            const dest = info.outputFileDirectory + pathDelimiter + info.outputFilenameBase + '.' + outputExtension

            const ffmpegArgs = [
                '-y', // overwrite
                '-i',
                src,

                ...conversionFlags,

                dest,
            ]

            console.log(`convertWebm: calling ffmpeg with args=` + JSON.stringify(ffmpegArgs))

            const result: FfmpegExecResult = await ElectronIPC.ffmpegExec(ffmpegArgs)

            if (env.TestWebmConverterConversionDelay) {
                await sleep(env.TestWebmConverterConversionDelay)
            }

            const code = result.code
            const message = result.message || ''

            if (code != 0) {
                // error
                console.log(
                    `convertWebm: conversion ended with non-success error code ${code}; ` +
                        `error message: "${message}".`
                )

                onError(code, message)
            } else if (code == 0) {
                // success
                console.log(`convertWebm: conversion succeeded. Calling deleteFile on "${info.outputFileFullPath}"`)

                onSuccess({
                    ...info,
                    outputFilename: info.outputFilenameBase + '.' + outputExtension,
                    outputFileFullPath: dest,
                })

                ElectronIPC.deleteFile(info.outputFileFullPath)
            }
        },
        [pathDelimiter]
    )

    return {
        convertWebm,
    }
}
